import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {
  SectionHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";

const A = styled.a``;
const Footer = styled.div`
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 1050px) {
    display: block;
    padding: 20px 0px;
  }
  @media screen and (max-width: 600px) {
    padding: 40px 0px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 35px;
`;
const FirstCell = styled.div`
  font-family: "poppins-SemiBold";
`;
const NextCell = styled.div`
  font-family: "poppins-SemiBold";
  /* padding-bottom: 20px; */
  text-align: center;
`;
const SecondCell = styled.div``;

const Socials = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 366px) {
    /* display: block; */
  }
`;
const Sociallinks = styled.a`
  text-decoration: none;
  cursor: pointer;
  margin-left: 10px;

  display: flex;
  align-items: center;
`;
const SocialText = styled.span`
  font-size: 15px;
  word-break: keep-all;
  color: #fff;
  text-decoration: underline;
  padding-left: 10px;
  /* font-weight: 600; */
  @media screen and (max-width: 900px) {
    color: #fff;
  }
`;
const Text = styled.span`
  font-size: 15px;
  color: #fff !important;
  /* font-weight: 600; */
  @media screen and (max-width: 599px) {
    text-transform: lowercase;
    display: none;
  }
`;

const Cells = styled.div`
  @media screen and (max-width: 599px) {
    display: none;
  }
`;
const Cells1 = styled.div`
  display: none;
  @media screen and (max-width: 599px) {
    display: flex;

    padding-bottom: 10px;
    place-content: center;
  }
`;

const Address = styled.div`
  font-size: 14px;
  @media screen and (max-width: 1050px) {
    padding: 20px 0;
  }
`;
const SocialImage = styled.img`
  width: 100%;
  height: auto;
  max-width:20px;
`;

const index = () => {
  return (
    <div>
      <Container maxWidth="xl">
        <Footer>
          <Address>
            Hexape coin Smart contract:
            0xe36ac872eb1aefcf746feb6728b81b38fc6d75b2
          </Address>
          <SecondCell>
            <Socials>
              <Text>Follow us:</Text>
              <Sociallinks href="https://twitter.com/hexapeeth" target="blank">
                <SocialImage
                  src="/images/twitter.png"
                />

                <SocialText>Twitter</SocialText>
              </Sociallinks>
              <Sociallinks href="https://t.me/hexapecoin" target="blank">
                <SocialImage
                  src="/images/telegram.png"
                />
                <SocialText>Telegram</SocialText>
              </Sociallinks>
              <Sociallinks
                href="https://medium.com/@derrion/hexapes-coin-rise-of-the-apes-4cf486894d9b"
                target="blank"
              >
                <SocialImage
                  src="/images/medium.png"
                />
                <SocialText>Medium</SocialText>
              </Sociallinks>
            </Socials>
          </SecondCell>
        </Footer>
      </Container>
    </div>
  );
};

export default index;
